module.exports = __webpack_public_path__ + "img/book-cover.94a8c8e1.png";